/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react';
import {useParams} from 'react-router-dom';
import FormCambiarContrasena from './FormCambiarContrasena';

function CambiarContrasena() {
	const {token} = useParams<{token: string}>();
	return (
		<div className="flex justify-center">
			<FormCambiarContrasena
				data-testid="form-cambiar-contrasena"
				token={token || 'none'}
			/>
		</div>
	);
}

export default CambiarContrasena;
